var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInputPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.79316 0.526601C1.81679 2.61136 0.325209 4.55517 0 6.46086C0.0538601 10.7601 4.1081 16.0837 8.9799 20.9483C13.826 25.7872 19.4387 30.5641 23.519 29.9458C25.4367 29.6199 27.3931 28.1166 29.4954 26.1255C30.1706 25.4816 30.1702 24.096 29.4821 23.4087L25.3328 19.2659C24.6172 18.5513 23.2291 18.551 22.3176 19.0333L19.5244 21.0783C18.0338 22.3483 14.8932 19.2322 12.8083 17.1506C10.7283 15.0737 7.55441 12.2537 8.89231 10.4317L10.9345 7.65048C11.4107 6.74958 11.4104 5.36399 10.728 4.68265L6.59516 0.555987C5.85793 -0.180222 4.46993 -0.180565 3.79308 0.526827L3.79316 0.526601Z",
    fill: "#838383"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInputPhone);
export default __webpack_public_path__ + "static/media/icon_input_phone.d143163493d2326e483e1cd52da7264f.svg";
export { ForwardRef as ReactComponent };